<template>
  <div>
    <div v-if="manual === false">
      <div>
        <UInputMenu
          v-model="selected"
          v-model:query="query"
          :search="search"
          :loading="loading"
          placeholder="Find address..."
          trailing
          icon="i-heroicons-map-pin"
          by="formattedAddress"
          size="lg"
          class="z-20"
        >
          <template #option="{ option: address }">
            <span>{{ address.formattedAddress }}</span>
          </template>
        </UInputMenu>

        <div class="mt-2 flex justify-end">
          <UButton
            variant="link"
            size="xs"
            @click="manual = true"
          >
            Enter address manually
          </UButton>
        </div>
      </div>

      <div id="address-autocomplete-tag" />
    </div>

    <div v-else>
      <div>
        <UInput
          v-model="model.address"
          placeholder="Address"
          size="lg"
          class="z-20 mb-2"
        />
      </div>

      <div>
        <UInput
          v-model="model.address2"
          placeholder="Address 2"
          size="lg"
          class="z-20"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BAddress'
}
</script>

<script setup lang="ts">
import Radar from 'radar-sdk-js';
import debounce from 'lodash/debounce'
import type { ModelRef } from 'vue';
import type { User } from '@@/types/user';

const radar_test_key = 'prj_test_pk_7d0b8d3107d27df9fb890c5141faeb27f218a146'
const radar_live_key = 'prj_live_pk_352457a5eebd2c0766f55e0d63071d96c36a082e'

Radar.initialize(process.env.NODE_ENV === 'development' ? radar_test_key : radar_live_key);

const model: ModelRef<User | undefined> = defineModel()

const props = defineProps<{
  disabled: boolean
}>()

const loading = ref(false)
const manual = ref(false)

const query = computed({
  get: () => model.value?.address,
  set: (address) => {
    if (model.value) {
      model.value.address = address
    }
  }
})

const selected = ref()

async function search (query: string) {
  loading.value = true

  if (!query || query.length < 3) {
    loading.value = false
    return []
  }

  try {
    const result = await Radar.autocomplete({
      query,
      limit: 5
    })

    loading.value = false

    return result?.addresses || []
  } catch (e) {
    // console.log(e)
  }

  loading.value = false
}

watch(() => selected.value, (value) => {
  if (value && model.value) {
    model.value.address = value.formattedAddress
    model.value.address2 = ''
    model.value.suburb = value.borough || ''
    model.value.city = value.city
    model.value.region = value.state
    model.value.postcode = value.postalCode
    model.value.country = value.country
  }
})

/* export default {
  name: 'BAddress',
  components: {
    TextField
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: false,
      result: null,
      sessionToken: null,
      focused: -1
    }
  },
  computed: {
    _value: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isDev () {
      return process.env.NODE_ENV === 'development'
    }
  },
  mounted () {
    Radar.initialize(this.isDev ? radar_test_key : radar_live_key);
  },
  methods: {
    fetchAddresses: debounce(async function () {
      this.loading = true

      try {
        const result = await Radar.autocomplete({
          query: this._value.address,
          limit: 5
        })

        this.result = result
        this.loading = false

        this.$refs.dropdown.open()
      } catch (e) {
        console.log(e)
      }
    }, 500),
    setAddress (result) {
      if (result) {
        this._value.address = result.formattedAddress
        this._value.address2 = ''
        this._value.suburb = result.borough || ''
        this._value.city = result.city
        this._value.region = result.state
        this._value.postcode = result.postalCode
        this._value.country = result.country
      }
    },
    handlePredictionClick (prediction) {
      this.fetchPlace(prediction)
      this.$refs.dropdown?.close()
    },
    handleInputBlur () {
      setTimeout(() => {
        this.$refs.dropdown?.close()
      }, 200)
    },
    handleInputFocus () {
      if (this.result?.predictions) {
        this.$refs.dropdown?.open()
      }
    },
    handleInputKeyUp (val) {
      const addresses = this.result?.addresses

      if (addresses) {
        const focused = this.focused
        const next = focused + val

        if (next > -1 && next < addresses.length) {
          this.focused = next
        }
      }
    },
    handleInputEnter () {
      const addresses = this.result?.addresses

      if (addresses) {
        const focused = this.focused
        const address = addresses[focused]
        this.setAddress(address)
        this.$refs.dropdown.close()
      }
    }
  }
} */
</script>
